import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTenantAuth } from '../contexts/TenantAuthContext';
import {
  Workspace,
  getAvailableWorkspaces,
  getRememberedWorkspaceRoute,
  getWorkspaceFromPath,
  getWorkspaceHome,
} from '../lib/workspace';

export function useWorkspace() {
  const { tenant, admin, isAuthenticated } = useTenantAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const role = admin?.role;

  const available: Workspace[] = isAuthenticated ? getAvailableWorkspaces(tenant, role) : [];
  const workspace = getWorkspaceFromPath(location.pathname);

  const switchTo = useCallback(
    (target: Workspace) => {
      if (target === workspace) return;
      navigate(getRememberedWorkspaceRoute(tenant?.id, target) ?? getWorkspaceHome(target, role));
    },
    [workspace, navigate, tenant?.id, role],
  );

  return {
    workspace,
    available,
    hasClient: available.includes('client'),
    hasExpert: available.includes('expert'),
    showToggle: available.length > 1,
    switchTo,
  };
}
